import React, { FC, useRef, useState } from 'react'

import { useOutsideAlerter } from '../../../../../hooks/useClickOutside'
import { UnknownQuestionTableRowDisplayProps } from '../tableRow/customCells/QuestionCellContent'
import * as Styles from '../styles'
import * as LocalStyles from './styles'
import { Highlighted } from 'tabs/data/components/Highlighted'
import { useUnknownQuestions } from 'tabs/nlp/components/unansweredQuestions/context'

export const UnknownQuestionTableRowDisplay: FC<UnknownQuestionTableRowDisplayProps> = ({
  question,
  similarQuestions,
  isLastThreeQuestions,
}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null)
  const [popupOpen, setPopUpOpen] = useState<boolean>(false)
  const { search } = useUnknownQuestions()

  const togglePopup = () => {
    setPopUpOpen(prev => !prev)
  }

  useOutsideAlerter(wrapperRef, event => {
    if (!event.target.closest('.MuiAutocomplete-option')) {
      setPopUpOpen(false)
    }
  })

  return (
    <div ref={wrapperRef}>
      <LocalStyles.DropdownButton onClick={togglePopup}>
        <Styles.AnswerText>
          <Highlighted text={question} highlight={search} />
        </Styles.AnswerText>
        <LocalStyles.PolygonDown isVisible={popupOpen} />
      </LocalStyles.DropdownButton>

      {popupOpen && (
        <LocalStyles.SimilarQuestionsDropdown isLast={isLastThreeQuestions}>
          {similarQuestions.map((q, index) => (
            <LocalStyles.SimilarQuestionText key={index}>{q}</LocalStyles.SimilarQuestionText>
          ))}
        </LocalStyles.SimilarQuestionsDropdown>
      )}
    </div>
  )
}
